const City = {

    // FIELDS
    "city": "City",
    "name": "Name",
    "description": "Description",
    "state": "State",
    "country": "Country",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "list_title": "City",
    "filter_title": "City Filter",
    "add_title": "Add City",
    "update_title": "Update City",
    // TABLE HEADER
    "table_name": "Name",
    "table_state": "State",
    "table_description": "Description",
    "table_country": "Country",
    "table_state": "State",
    "table_status": "Status",
    // ERROR
    "error_name": "Enter City Name",
    "error_description": "Enter Description",
    "error_state": "Select State",
    "error_country": "Select Country",
    "error_status": "Select Status",

}

export default City;

